import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'WorldLayout29',
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: '1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2',
      type: 'Container',
      name: 'backgrounds',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '3',
      type: 'Container',
      name: 'nodesContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '4',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map29_export_1',
      parent: '2',
      data: ''
    },
    {
      id: '7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1352,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map29_export_2',
      parent: '2',
      data: ''
    },
    {
      id: '8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2704,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map29_export_3',
      parent: '2',
      data: ''
    },
    {
      id: 'ff025e88-392c-496e-a6ce-64c68763f7fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4056,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map29_export_4',
      parent: '2',
      data: ''
    },
    {
      id: 'e9d35b7c-5732-4826-9a79-15376e8b94cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5408,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map29_export_5',
      parent: '2',
      data: ''
    },
    {
      id: 'be5c60d0-5ebf-4b98-b1b0-c2ad42913a42',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6760,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map29_export_6',
      parent: '2',
      data: ''
    },
    {
      id: '7761abc4-90ea-4259-a23f-69558a3d1d82',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8112,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map29_export_7',
      parent: '2',
      data: ''
    },
    {
      id: 'd71b8eaa-3180-4e1d-a9bf-8218794dab03',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9464,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map29_export_8',
      parent: '2',
      data: ''
    },
    {
      id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 327,
      y: 463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cfc191e5-de8a-4d31-a9e5-4acd1efd8ee4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 417,
      y: 442,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bc5fc7ca-9fee-4b06-8282-f06da2a7558c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 496,
      y: 398,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ffe93f63-1d88-4670-8c40-405ce0801a88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 563,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '343ff901-a19d-462b-9c7d-dfdd00b43956',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 613,
      y: 277,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '539bd34c-d88d-44e7-8493-d0cc21ae63ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 705,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f77810e6-97d4-4c6c-8433-bdd5aaca1051',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 792,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '759cdf8e-ee7c-4056-97a4-9c125d95f2a1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 839,
      y: 359,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '17af076b-edab-41a5-a687-af63bb786c48',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 850,
      y: 444,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd08cff26-fd82-4290-a72c-fb334139f8a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 936,
      y: 479,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4b373e88-c863-4d38-86f6-3aefaf1ebbd7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1032,
      y: 470,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0624709d-8421-4821-82d6-0f6065cf17eb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1108,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6fbe7647-bb86-40a1-9053-46bb27233afe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1138,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e4a115c2-a6dc-460d-bbfd-2de34276ff14',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1218,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5e9a66cb-3bac-416c-975f-4d6a8557fe2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1310,
      y: 300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1dc6a486-42a2-4323-94a6-47d92626b01b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1400,
      y: 326,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f11db01d-22a5-45da-99d2-8fe90b7d64ba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1491,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '46545c78-9fea-4b5d-afe6-efd7ef0e843b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1581,
      y: 411,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9f969a8e-a415-40e9-a649-4e90d1fb9033',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1671,
      y: 454,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f88b6a0e-d91f-4661-bcea-cd2417931305',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1767,
      y: 481,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cbd46191-5bb6-4e76-927f-22998b7ede58',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1869,
      y: 492,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '30d2d5c7-9485-4368-8377-fd49499a162f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1959,
      y: 456,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '50d74d16-fbb2-4546-80e0-3f586dc2c4d9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2038,
      y: 406,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a463fc05-95e8-40a4-8c17-69a7977d8f31',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2121,
      y: 358,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '37b40dec-9f3a-4eab-b124-ba2995db8bf4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2215,
      y: 325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3565780a-e3bd-4aeb-bf3f-24f1eb2d2e3b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2319,
      y: 325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c327adb0-f084-4743-b946-a8740e9eb2bf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2413,
      y: 356,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f92feb81-065e-4bf7-b8bf-1eb547be818e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2490,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '66e6831f-2d7b-453e-b3b7-0c5b97db35c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2563,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7e587777-8c73-4450-b9db-f7b2b88e6f72',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2657,
      y: 504,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '07687595-1fe4-4a6a-b6fb-a3da1375a251',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2754,
      y: 529,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '66b8282f-3a79-40ed-93ec-5a4509955844',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2851,
      y: 507,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '723a4597-d427-4de8-9dca-4ade96ee8be7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2930,
      y: 455,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '94324b8d-4f24-4eb7-8a0b-0bf8e0dc5feb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2995,
      y: 392,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0397478b-b8f6-454c-b70f-a5cf962f22cb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3067,
      y: 329,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e727f4b8-307b-444d-a9b8-f881cc880a54',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3157,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6f3bc83b-00d1-4da2-99ab-090b0de40724',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3256,
      y: 286,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'aa456197-fef4-45f0-9302-232270dce348',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3352,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7d40de18-b32c-40e4-89ee-0f325ee9fd28',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3445,
      y: 337,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '14ec0078-3e91-4a9c-b4a7-50cce12f0d4f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3535,
      y: 377,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd07998ed-cdd5-40ec-92f9-a9574cb01fea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3622,
      y: 429,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a24a46be-1493-4688-8a2f-3b9d2d646cb2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3708,
      y: 483,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '159a682d-cfea-4e3b-a7b5-482e285e6976',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3805,
      y: 519,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0956c894-cac9-421a-a8fd-e5056de7dd03',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3906,
      y: 530,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '57b69d23-12fe-4b8a-a60f-85fbf61029e5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4007,
      y: 510,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2ef332f8-1758-42ba-b4ea-45516be89efc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4103,
      y: 469,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7a9b3bc8-d07a-4b17-b2c1-bce5a006868d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4182,
      y: 418,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b90c1844-b8d9-489f-ac5d-59137c5fcebc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4263,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ed4e26ce-9388-4562-bf99-4ab76a2125f5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4348,
      y: 325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '93eab4a7-b96a-4e76-a6cb-29f3eb28befc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4442,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8dfe9cd7-2539-4a2c-a9f1-2d14e4d6bac2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4538,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7e2eba71-98be-4bc1-ad21-b70c121f7c8e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4635,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0df70a80-48ca-4206-b956-8a4380ac0553',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4729,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '67c6d62a-3557-4bec-a2ba-399c6719596b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4818,
      y: 339,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '63a1811f-0b55-49f9-9ac0-5184ad0a5054',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4902,
      y: 378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8c200218-ae0b-4aeb-a750-7f2bace491aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4989,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '86c77ea4-af58-44a7-a35b-8b9a84708263',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5078,
      y: 443,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '510e51db-5e01-4e2c-bda1-d63e9c8113cc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5168,
      y: 465,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '388ee997-5af3-432f-8157-96440667789d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5261,
      y: 460,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1d129640-996b-4ab6-80dc-0052f01fe378',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5353,
      y: 451,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '14e30aa1-8d95-489c-980d-3c0962adfc71',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5445,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '64ead4d4-c335-4d90-b93a-ad4458f0f959',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5510,
      y: 372,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5a8ab65c-1c8b-41cc-82c1-03e6a0e90ed6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5599,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b1c3b9ae-fad2-4eff-b511-5d5c81ff215b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5695,
      y: 330,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a3358a3f-427d-4767-b110-173814acf3e7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5780,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7fcb7157-369a-4b1b-bf6c-245cb403ac22',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5874,
      y: 278,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '65907384-8efd-46fd-bab0-5a3264fe7d4a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5967,
      y: 274,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8fe2c7bf-fdf7-4ebb-9fba-6696778f1c89',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6061,
      y: 270,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '96133add-f7ad-4613-83d1-a1117fba8220',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6159,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '87f8a5fd-53bd-49b4-ba32-0936dfbcc59a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6253,
      y: 266,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e3076adb-1f61-489c-92e7-4e32449b6889',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6346,
      y: 260,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '43a65b24-85d1-4e5e-950f-e2bc6fcdf7c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6442,
      y: 266,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '97b02dfa-586e-4108-85e2-9c56b8464e7f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6534,
      y: 285,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1cf63b42-2ca3-4fcb-8a4b-ab8ad7c6b26e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6623,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bcc3087c-a37f-4cc9-aaa7-3cc586637d0e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6706,
      y: 351,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '373f2858-20fe-4571-a713-38ee0a94e5bd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6801,
      y: 409,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a70a1ec2-8889-4aa1-892b-59582bca0f14',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6883,
      y: 460,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fe5d1920-2ad8-4a8c-8e12-a850c0acc912',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6978,
      y: 502,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e003f5df-6666-424d-95cd-fd8f17bc9172',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7087,
      y: 520,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5bbc21f2-8f68-4575-b630-418c8f33359a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7190,
      y: 505,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8815f386-eec8-4d6d-8355-5c495e7af8d5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7280,
      y: 465,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7cdfa0e3-ca8f-4607-8a2b-a9b5f2b44793',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7354,
      y: 406,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'dc03ef66-0945-48b4-9055-f4d02e6d577c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7424,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '81878499-b41f-4ee0-83c0-f1e7f52ca728',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7521,
      y: 315,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '090612a0-b32c-4690-8a8c-6802d7569b40',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7620,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fc2bb642-5cb8-4eb9-9dff-839baed8ce22',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7698,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7052f4ed-9978-4b42-9fb3-bcaab1bc4f73',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7781,
      y: 454,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b1375e6f-2154-43ee-bea1-c2cf454b2930',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7883,
      y: 443,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '31376fd8-8923-447f-989b-51f95db0e691',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7962,
      y: 387,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '39cd5982-2bb4-4aa6-9409-a425ebea27bf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8045,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fd14656a-2a79-4695-be3a-33994cf91e60',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8143,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a0ee17fa-6d62-40dc-89f1-5e51c8c87f1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8239,
      y: 334,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'de2bd5d0-0e07-4d2e-82c4-1f54029e03cb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8329,
      y: 371,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'df5b2501-728a-4acc-8501-3d2a8fa5989c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8405,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0bee4d9f-ab76-43ea-b371-1c285191af39',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8458,
      y: 499,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '61384b62-56cc-4f85-af1f-6acfc80dca38',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8551,
      y: 521,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b8b9e519-9519-498e-8f90-0e4c58517f5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8648,
      y: 506,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e9ba0ee2-ef21-45eb-ad63-3623d6e8333e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8737,
      y: 465,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a29ca407-e148-4e67-aa4e-f08628d330b1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8813,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c5de482a-49f3-4591-bf4a-101fe63c1e7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8899,
      y: 373,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e591852d-e840-47bc-bbe7-79d7e88c5dc0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8993,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1eaba286-da5b-48f4-bceb-b41ad0cff120',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9091,
      y: 377,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8ab12989-2ecc-4d12-9452-4404b9a7893d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9187,
      y: 408,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b15932ef-797e-4e20-acfa-63b8aa110ceb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9287,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3258c131-da30-42fc-be2b-fbb2331c9582',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9388,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2fe2363c-7560-4aa5-b6e7-6a412fe7e7f2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9482,
      y: 407,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '64f977f1-d650-49cf-b528-efc155ba8cdd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9548,
      y: 349,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '84145dc6-df49-4679-90d1-676cc9226aa4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9618,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bf094f69-ce41-4d07-852c-cb22dcaaeb8d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9710,
      y: 276,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74d18602-7edf-4561-aeb0-5c6982a67b91',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9804,
      y: 287,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a4158900-6f48-401b-b7cb-e17713c6e4a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9889,
      y: 313,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f3e02a46-609c-462b-8a6c-44cb69d4390f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9963,
      y: 358,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1ba990ac-1bcc-467f-affa-fd293847af9d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10011,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b3b3c868-5843-4fe5-8860-c3229bd0b184',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10081,
      y: 482,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6336b473-eaca-44c8-8348-d7de16f64dac',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10162,
      y: 523,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '615c4593-50c5-49c9-a71f-e815444aa58d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10256,
      y: 537,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '95427ef7-e0d7-487b-a6e7-fb1dc04b4323',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10332,
      y: 490,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cd851608-82af-4456-8bb1-081eab30d8d5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10398,
      y: 433,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a4eb877b-17e1-4899-b316-edce153f24fb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10473,
      y: 384,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '08c28d94-e168-4500-8107-7638e4bece6e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10562,
      y: 396,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '110',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '185',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '219',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '224',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '1b355a2e-d409-489c-8af4-a150c082b42b',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '106',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '160',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '631194d4-ad73-4366-a65f-21797e8dc249',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'af38acd5-a0e4-43d7-856f-fef8f3b120a3',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '74092e03-0544-42a0-a499-3278f19873a5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '583acaed-3914-470b-a17f-69f0e67d92ab',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'ea7f8b33-ad80-48d6-98f7-0540c1ec4100',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '214ea0e2-d913-4c42-a718-1f4bc72d2b79',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '82630176-2990-4416-9aea-7563d486a8a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 291,
      y: 679,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '44739f0d-6d4c-410a-bd11-a7f7151a6e86',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 363,
      y: 741,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c9e7d935-3c22-416e-abe0-578e4ae5bd43',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 440,
      y: 638,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f9295ea4-acf4-4fe9-8584-2e202c1982f8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 589,
      y: 587,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '7afff7f1-a4ec-44c8-b11c-99b947519f4b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 727,
      y: 538,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '6d332177-6c73-44e9-9a31-23e540f15fa8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 492,
      y: 684,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '30fc34a0-1bce-40cf-ac0b-75bf89f80d41',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 643,
      y: 636,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '66caf2b5-7c8e-427b-9482-4601e33c0a57',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 780,
      y: 579,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '70e4106a-8246-4179-991b-8f2dc4c16679',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 540,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '552798bc-dde1-49d3-b68f-7f45e531d1da',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 697,
      y: 682,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '65266e45-8e04-41b2-8457-724c9cef553e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 832,
      y: 624,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '149ba803-8985-4cfc-b12e-0e772618a17c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 592,
      y: 784,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '685088f9-fc05-4a56-865d-30b7568416ef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 415,
      y: 805,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '51342b1e-dcbd-44f6-9a4a-9f489f251a8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 746,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'e14f02e0-5f78-46be-94ef-10ac58907543',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 798,
      y: 782,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '28b073fd-bc56-418c-b89f-6558557b8937',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 880,
      y: 679,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a6954e12-eec7-4a75-9ab0-225f8fbd5b1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 930,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '540d6da4-118a-4537-847f-a3bd97c53681',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 978,
      y: 767,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'e9591ff9-701a-486e-8e6f-d5c4f50b8c5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 626,
      y: 113,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '6ff6f234-a5c2-4452-8f9e-e1b5b2778b30',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 694,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '7172a281-2aa0-4efb-9c82-38cebf3f1712',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 729,
      y: 176,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '24e326d1-2b6c-4c40-a843-2298986d6678',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 795,
      y: 129,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '65c3d47f-3665-471b-9f96-f1017d6ce976',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 857,
      y: 73,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '736a3bb2-580f-48ca-bb00-d5ee2afcbe77',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 909,
      y: 23,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd604a8ad-fcc9-47b0-aeda-fc2b742bd4f0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 894,
      y: 184,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c14cf1fe-a05a-4f61-a567-89675b583438',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 950,
      y: 139,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fef4e23f-7706-4466-a2c3-fdd29acd4822',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1006,
      y: 87,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '2cfce600-1f62-4fbb-9800-8b2f2046fcb7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1064,
      y: 36,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '2fcb8f85-aaa2-46f9-90f7-2e7344f4a747',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1018,
      y: 249,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ea9eb7be-6f45-4c7e-9d9d-c1e38c82f76d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1081,
      y: 199,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '122dbb34-e880-45de-a957-42da4d38a198',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1141,
      y: 146,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'e2e4c883-2966-46e0-89c5-f35ad8db8526',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1192,
      y: 93,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd749153c-cf93-467d-87bf-43d7fedb4ac8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1252,
      y: 38,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd06f2c93-fd89-4eea-9849-f024e013919c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 541,
      y: 30,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b8c77ed8-7953-47bf-935e-85d73e0c96e3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 482,
      y: 76,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '3ab178b6-0173-440a-836f-eba771e189fc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 565,
      y: 169,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '74',
      data: ''
    },
    {
      id: '66fa4cfa-7d39-42d9-b691-1f874eb7c1e9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1728,
      y: 247,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'd8e029b1-1a75-4c0c-89f5-df76b66ef637',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1791,
      y: 198,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c8a01e8c-6356-4019-84f4-3c8e14020c51',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1853,
      y: 143,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '5aea110a-fb47-4add-a2a3-f792a4c0a32f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1913,
      y: 87,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f18ca88a-4411-4b54-8f7c-11a024386cff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1974,
      y: 30,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'bd8510e8-a5c9-46b9-a5e2-962552c433f0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1890,
      y: 292,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '3bd0175b-cc71-478b-96ee-1269cbd9a792',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1948,
      y: 238,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '7a5052e6-1d1a-4ea9-adcd-e13ce89520a5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2002,
      y: 195,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'aa0923d2-93d0-4e44-b65f-64277900abe4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2057,
      y: 143,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '4f029dd8-5f6e-4719-b67c-c6dcb6e6c6b5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2113,
      y: 90,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '4c242a49-417f-4c56-81b6-bf992f7d431b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2173,
      y: 40,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '2a06bd8e-46d2-41cb-b98d-197d485eaf66',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2193,
      y: 209,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '269d1c12-8149-4d4c-95e2-747cf9a90a38',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2252,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '34829151-f44f-48f1-a20d-c639e3402096',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2309,
      y: 107,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'efe37bda-a8c4-4fbe-a466-d0577e4afab8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2363,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '93200787-9d9f-4980-b1bb-62ae97db3b86',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2409,
      y: 192,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b2331941-6bf7-462a-a1d7-2274696284d1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2471,
      y: 141,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '607696e4-e5b6-4389-a75f-a31ace8564c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2528,
      y: 93,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '96d07e32-2586-42ed-bd10-08d1993bc6f4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2585,
      y: 40,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'da325f7e-d44b-40a5-aadc-199838951532',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2552,
      y: 259,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '92bea8af-b18c-424c-a3b3-1065d2501b3c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2609,
      y: 212,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '573386d3-a6f4-4d51-9cc4-4432e8f61093',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2664,
      y: 161,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '14841100-2a7f-4b4e-a0a9-a619f8a70041',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2715,
      y: 110,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'df1bfa25-ae5f-4c72-b08d-a3fce7400c2a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2769,
      y: 55,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '01ebdf87-181e-4776-a8c7-9ccc666848f3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1860,
      y: 642,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '5f8c4ede-8b13-44d1-bb72-88c2a555cd8a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2308,
      y: 793,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '96c48714-9310-40af-ba82-4a0404bf552b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2460,
      y: 648,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '0b2854c3-8b80-4b48-9ada-7eeefe8489e0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2406,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '35b1641b-cecc-4565-a954-3f7d25f47166',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2355,
      y: 737,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '14b78f51-1cfa-451f-80d8-1e6bfebbee7c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2090,
      y: 807,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '1f9a0f1c-ac59-4d11-8923-a136d6a80cdc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2514,
      y: 605,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'abcc5322-bfb4-447e-b695-dd7db9dd9432',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2137,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '808c0c85-3efe-404e-955b-c5c12972cf27',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2191,
      y: 702,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'e43d15bd-1050-4a59-9c89-b75c00389647',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2240,
      y: 651,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '2112c356-3aa8-4fc4-8878-010f37b1414f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2292,
      y: 604,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '8f97d4ee-4726-4f34-b181-78d76afb54be',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2351,
      y: 558,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '9ca42d5f-b73c-47c6-acc1-4abd2c3b20b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1920,
      y: 757,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '10b1bdd4-94ff-41ae-83d8-461d7e560ae2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1971,
      y: 710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'fa26306d-5fc4-46fc-9ff8-31b789f02142',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2016,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '2b38d1c8-7277-4fa7-a31d-c142380a888c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2071,
      y: 624,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'a4104664-918e-4bb2-8ce6-f355c1e1341a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2126,
      y: 576,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '50d78fab-2cef-4082-99aa-4cfdfdcd6ab8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1739,
      y: 739,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ed881760-6632-4132-a1f1-5e0c9f5a271f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1800,
      y: 690,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_4',
      parent: '110',
      data: ''
    },
    {
      id: '24b18308-aec7-4a29-ae53-aeb29e9cf95f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3419,
      y: 625,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '36ae0b01-f778-4aa2-b70a-65523397687b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3473,
      y: 675,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9aa67fba-41ce-4ab4-8cd1-cd7ec161a1e2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3529,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'd97148ff-d5bf-4adb-b851-798caf4a6ac5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3588,
      y: 780,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '73232bb8-8607-42b3-a703-3d87da237234',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3674,
      y: 667,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9613916b-2a4e-44c1-99e0-6195018ebb10',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3732,
      y: 720,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '2c93d83f-4a07-45ff-b578-4c7a9827176c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3795,
      y: 780,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'c92981fa-7d8f-4f50-9aed-96ae6d66305f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3906,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'a52b0892-6bc3-429a-897d-d4ab3427b0da',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3966,
      y: 747,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '285feb16-f0e7-48f2-931f-a3937c8e4d46',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4028,
      y: 809,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'e40f0630-25fe-431c-bd30-69a0391bf390',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3410,
      y: 76,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'baaad8f5-70a4-41aa-aba8-907585db8d55',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3472,
      y: 136,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '75a02740-22c0-4c39-b356-423356a6d949',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3539,
      y: 196,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '1e77e507-e19d-4a69-8d3e-5b5406d74ad3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3603,
      y: 257,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'c5bacaab-0037-4685-a572-edbf674703cc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3666,
      y: 313,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '686a5b10-9395-4591-a04a-9ac5bddbf0c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3556,
      y: 44,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '8b8d0a91-bfa1-4fe5-b372-6bbcf5107622',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3619,
      y: 102,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'b6fdc681-aab2-49cc-98ef-b6f6e0c64644',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3683,
      y: 160,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'd860776e-77a7-42f4-84d1-9f8d9976205d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3748,
      y: 215,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'da196379-d230-46c0-b018-a4a89bfbe24a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3810,
      y: 271,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '6ed3c581-391f-4369-83cf-9fd8932a1d82',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3884,
      y: 344,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'b7d47040-0655-427e-ae7b-50f4012980a4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3734,
      y: 24,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'ddb05183-c65d-4e6b-8435-c65fe62a059d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3794,
      y: 80,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'aca5c771-2812-4644-be31-67c098c73b64',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3863,
      y: 143,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '589dc39c-ba72-4e59-a56b-abe4c63bad9b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3928,
      y: 199,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'cfc54aee-9f29-456e-bd53-1c18c448dd9c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3997,
      y: 257,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'afe3d1f4-11c2-42a0-a9b1-7f31923accf4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4061,
      y: 313,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'dd539e95-bc94-4541-9a2e-49ec21664bef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3928,
      y: 29,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'f8c5fd77-f576-466e-ba54-807e7b148e8a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3990,
      y: 80,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '45371e71-809b-4514-afdc-cf55d304115d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4048,
      y: 134,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'f65b6aeb-41cc-4bac-b0b5-a28c8c81f784',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4115,
      y: 192,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9311add8-4985-41af-a619-ead59598eee9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4184,
      y: 248,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '79c76f8d-a12b-4d7d-b2bc-4934b7af527c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4327,
      y: 205,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '165386e9-58fb-4c4d-8da1-1518a2e554ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4255,
      y: 146,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '5ba399a7-077f-43ca-b526-678a9a04a3b6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4192,
      y: 91,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '8a9d596a-ea29-4f51-a2c8-ddd2b16b485c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4135,
      y: 42,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '5071425b-2827-4214-b7d6-f43a7a5896af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4237,
      y: 652,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'ccb8e233-fabb-4045-a658-73cd51b673f4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4301,
      y: 710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '8d83336f-7ae9-43e8-ac6e-6bf0f78d089f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4362,
      y: 759,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '9b19fefb-a2bd-4fba-b4df-17ee73adbbab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4366,
      y: 590,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e6da3f3d-b546-4242-98ef-7ad80201593e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4421,
      y: 638,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'aa0cd5d7-fcd1-4bb2-b85e-472259b22c17',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4478,
      y: 690,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'ff5b5cda-7a41-412d-aa09-b5ab8fab52c8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4541,
      y: 740,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'd7f29371-44cd-4498-a4ed-18ed22cd97d2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4496,
      y: 539,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '9a3bd32a-a83f-47c9-b89b-b33666d84e94',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4554,
      y: 587,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '6bb7effa-e327-432d-ae76-ea5f1563b66a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4618,
      y: 638,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '61fe5037-6160-4ce5-904d-75faf500d33a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4683,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'f924ac04-a046-41a1-8a15-5394639a4b4a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4746,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '69139570-604d-4fa8-b306-e8cc0418c523',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4805,
      y: 806,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '72e134ca-425f-4085-b37a-06e7456a77d6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4698,
      y: 544,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '03aebf94-4d27-444f-9c34-3819e83ff3e5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4759,
      y: 590,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '6bfcf367-eca1-4f9a-a465-56724c9f57c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4820,
      y: 644,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '42bab60b-e21c-483f-b483-8ea6d46a00b5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4874,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'd94eba04-f0e1-47c4-b35b-ca96cde0482c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4931,
      y: 741,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'bc9d9057-3a7f-4ace-91dc-564e323c70db',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4986,
      y: 793,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '25b4a0fe-91d2-4481-a105-55512d152f61',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4944,
      y: 590,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'dfec8567-0108-4b5e-8063-2dd30faf9ea2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5004,
      y: 636,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '15b68334-1f0f-40aa-af8d-7d29b3c80d02',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5062,
      y: 686,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '48e0d8a5-df25-469b-b94b-64cb98bc3ba3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5124,
      y: 741,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '928f4c2e-72d0-4b95-8b48-20612f838840',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5181,
      y: 798,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'd21d2791-9cf2-4564-b4fb-7dcebe4a5184',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4748,
      y: 174,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'fc0c7387-d8c2-4c99-9cd6-cefdc245538f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4810,
      y: 118,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '6e07b90f-1596-4149-b0cb-14e5e3d6693a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4872,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'bbccc96f-0285-40f3-bca5-e14728bcf13b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4936,
      y: 12,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '6ef53994-d9f2-4975-a73b-382baadf4ec3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4863,
      y: 243,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '8f3074b8-ceb8-406e-8895-6b5e143fb2be',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4932,
      y: 191,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e6b7ca33-df7b-49b1-87bf-d20d1e9d9e2b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4998,
      y: 128,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '9cad3977-1d66-4af2-8334-3c5c175f2bf1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5063,
      y: 69,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '18355069-937d-4bc6-ba97-84ab8444f547',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5118,
      y: 19,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '11da5b9c-57f6-465f-9d09-ac6b270e0e10',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5024,
      y: 286,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '330d1c47-02f4-4bfc-b653-eca4d8f73e08',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5092,
      y: 227,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '69a295f3-677f-45e7-8849-22c3fd8b339d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5153,
      y: 164,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '36270aa5-0f53-4ab8-96be-804c3e36cd4c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5219,
      y: 110,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '1368d5b4-7c8e-4764-89b5-afaeee5798d3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5277,
      y: 46,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '1c00d748-7c2e-4cc3-8943-418bb70cc402',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5235,
      y: 274,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'd562decd-1452-45c1-a039-b9f087f98365',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5299,
      y: 222,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'dd9646f8-51ba-4f86-92c0-1472c16323ee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5357,
      y: 170,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'f740fd55-c3cc-43c5-bc86-7e21f581a25f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5417,
      y: 114,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: 'f15ad448-3b25-448a-b5d4-63638c6e5d35',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5479,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '129bd4b4-a422-4987-b7c8-401ddb61e511',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4601,
      y: 794,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_4',
      parent: '185',
      data: ''
    },
    {
      id: '49570db3-88ba-4f38-95c7-3318ed9631ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5874,
      y: 472,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '4a53b799-4f93-4bd8-a028-b15b3ae5e7c9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6044,
      y: 555,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '85d23e61-8db6-4067-897f-8044127daefc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6157,
      y: 445,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '4c32cb25-45ed-45b2-8686-9bc4f7d2e478',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6392,
      y: 466,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'fea2b0d1-3367-4332-b75a-5a20a2c5efdb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6246,
      y: 590,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'b87c7056-4ce2-4108-8f83-dfddc4898ae0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6311,
      y: 740,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '74298c16-750c-40cc-a49d-d854629cbae7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6427,
      y: 632,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '76038d8e-f914-4a4e-920e-0da49dcd1f01',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6581,
      y: 561,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '0a8699b9-f011-4f03-a1ed-c46e43ce78eb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6586,
      y: 732,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'b9702425-5c04-492b-b8e5-727161a9e051',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6507,
      y: 174,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'f7d6f311-3087-4f59-857c-f529e330baf1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6704,
      y: 72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'f2f88627-390d-46ad-8a32-abb167d61c5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6781,
      y: 228,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '2248ba15-7d5f-4a77-9cfe-2630738082a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6907,
      y: 99,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: 'd89ced04-edb6-4ee6-87d6-58bc2bad5bd1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7109,
      y: 40,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '2a775538-0910-4637-867d-cf4941ea156e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7108,
      y: 186,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: 'c21a8d17-f56f-4185-a80a-51e779bcebd5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7003,
      y: 341,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '5915523e-5501-4565-b8d8-4fc975660eef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7109,
      y: 40,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '56a0f34a-1f18-4907-8e7b-29c522d73347',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7247,
      y: 283,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '0618e530-7884-4b27-b28a-c98b1267a2ee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7306,
      y: 120,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: 'dfcd9a09-13c6-44aa-a520-6635bac20f60',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7467,
      y: 212,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '943b9d02-266e-4330-89f7-222fe4c22879',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7618,
      y: 103,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '8fc8a972-b49a-4178-b642-4dac3dd7b806',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7899,
      y: 91,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '98e3dbb5-a66a-45e9-8b7b-0a4e3afcee4c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7510,
      y: 594,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '48922e32-853a-4f19-a55f-a6fb3f49097d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7313,
      y: 692,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '88717fd8-40e3-497d-92fa-eb7d5e68d544',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7982,
      y: 248,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '98786da8-0293-405f-8b9d-e2cd9778d5e2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8154,
      y: 221,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '60950b33-7cd9-497d-9e25-b2bdb728d6f0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7510,
      y: 773,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: 'ed43b973-734c-4475-810b-2ec5ea6c411c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7727,
      y: 713,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: 'cff462b8-efc2-4544-aa71-47671dd7abe9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7949,
      y: 684,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: 'e1c4972a-1f5f-4e7f-b783-b02d9319ebb1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8115,
      y: 586,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '31492809-f545-4f4a-974f-deb399198cef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8106,
      y: 754,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_4',
      parent: '219',
      data: ''
    },
    {
      id: '230d0e4b-abaa-45c0-be16-be68c68a2ec9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8543,
      y: 20,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'b0bea4a3-fbc0-4f94-bf2d-611ef3e53f3e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8565,
      y: 88,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '66862554-0708-41e1-a01b-9b0292392e4e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8627,
      y: 33,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd9781322-6cd1-4043-9736-0668ba8014e3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8600,
      y: 154,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '576d7974-53e2-4077-b236-58c11c31dd5f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8666,
      y: 92,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '39473a59-f087-471e-a5e1-b9061fb53b9d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8729,
      y: 36,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '477ce1ed-55d9-4ecc-87f7-f1113119f4dd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8654,
      y: 203,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '7ca3993b-e7c4-4878-997c-03f6cf00c687',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8713,
      y: 149,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '59039f2f-b761-43e5-b879-f4bec7dcf738',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8784,
      y: 85,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'a17a9b6a-e9cb-4341-b6fe-796e91ad4841',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8837,
      y: 27,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f2e42be4-1b8a-4d96-ab6a-2d667ce05097',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8706,
      y: 254,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '8c34ad4c-caba-4e82-a6ac-9252becc9007',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8759,
      y: 195,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '77123bee-da0f-45c5-9efb-d4d6b46a95a5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8819,
      y: 142,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '22102720-4ac4-4bd9-86ac-8ecf06edc7e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8883,
      y: 87,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e8e9c4d6-b4a4-4062-b92d-bd6b500803ab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8943,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'efc227c9-013e-4f42-82d8-4e5f3a1f2dd6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8805,
      y: 259,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd8adf432-98a4-4a15-815b-34a56fae186e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8868,
      y: 204,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '02045239-15b4-4f53-afd2-b6d8dff4e4fa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8923,
      y: 156,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '85e7ed19-2f4e-4164-b45c-bd6f3aac2508',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8982,
      y: 99,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '1a5afead-1054-4a64-8160-53dde3063caa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9048,
      y: 44,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '4c8e72af-65ef-418a-8ab3-1b7771983d88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8977,
      y: 211,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '9f291250-b27a-4a8b-9fcd-71a0bd224abd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9035,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '2068e979-fc8c-4505-a6b1-41e3ee6873e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9091,
      y: 94,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '6d4f78f7-1caf-4053-89e7-9f33dd4aa300',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9151,
      y: 38,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '3bf8265b-2bc7-4568-b487-fe641cc31f19',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9077,
      y: 214,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd32003b9-c735-49cc-92ee-5edee054de3e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9136,
      y: 142,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '4404c5af-dc42-48f1-901d-9abac7215937',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9198,
      y: 88,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f0c7fe4d-13fb-48ea-a2b9-4dc718d416d8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9257,
      y: 33,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '9cfa44bd-58ec-47fd-90d5-bd8e494dfb31',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9136,
      y: 241,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd85ace76-10d1-4643-b65c-3c2ba8b0a8ab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9186,
      y: 191,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'b454c175-5ba3-4361-9d0f-2b5c1fa06c88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9237,
      y: 139,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'cadedfab-882c-4cd8-b3bf-c2b44d713968',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9295,
      y: 89,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd1b6d6c7-daa2-48e4-a43b-3c4a2ef43133',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9356,
      y: 41,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '7d92e9f4-6dcf-4537-8963-016bb0f418b8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9213,
      y: 270,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '84dd75a8-1481-429d-bb5b-362b56f68266',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9270,
      y: 210,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '640c7860-055f-47b9-97dd-93ed8aeaf7b4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9326,
      y: 150,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '408e535a-a806-4d16-a721-0bdceed01dea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9389,
      y: 109,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '130516d9-442a-40c1-a96d-dc71ef6f29e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9344,
      y: 249,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '05198e1e-08be-4931-8030-dba5090cfa61',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9412,
      y: 193,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '8db2564d-4bf7-46c2-aaeb-3462abe1f891',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9436,
      y: 630,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '17509b12-dff3-48ec-b2df-5c7e50794af6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9315,
      y: 616,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '376985ef-1719-4b9b-aa3d-90786f629aa4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9382,
      y: 677,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '750925a4-8868-440c-bb42-de36fd6e07e6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9440,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'a6f30ea6-3753-4513-93f7-80d0ca76a487',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9194,
      y: 595,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'a076ba46-ccf7-4cbd-8a42-eafb7860df7b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9247,
      y: 650,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'cb0d08fe-9f0e-4115-b1b2-788e8f2001e8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9303,
      y: 706,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '98f88893-aadb-4e9e-a917-2cd5ee10ba71',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9361,
      y: 765,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f48bfee0-396b-4ef4-b7cf-52579a91b919',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9100,
      y: 608,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '987805e0-ce75-46a8-8445-740a944ff601',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9153,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '06bb87f4-f88e-4eaa-ac6f-0513e34cf3e2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9204,
      y: 712,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '8c8c90c5-2d3f-4ad9-a0d8-de8dfe0341f5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9260,
      y: 765,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'a0cf4a5c-34ee-4264-8585-d53750196e6f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9011,
      y: 619,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '537d25c6-377c-4891-b05e-a1027044626e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9058,
      y: 669,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e437a89d-ec96-4bcf-b43e-dd040638575d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9107,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd0db7fe9-fd25-48f3-bc8c-70266f210211',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9164,
      y: 795,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '08ec7423-1bd6-44e3-a413-72eff81023c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9060,
      y: 778,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '38232487-9a1b-45b8-a34d-90f2edcd0384',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8996,
      y: 717,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'fe8a107a-1579-49fc-80bd-3ca2cc33daa2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8945,
      y: 644,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'eea896e8-cfba-40bf-bfd7-11ee8b9935ad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8878,
      y: 707,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '9ef470d5-913c-4260-9ea2-52249e3640e2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8933,
      y: 760,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: '5a601b88-73cb-41cc-b7cb-f933c1d07556',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8825,
      y: 759,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e99330db-3123-4ac5-9364-e41648c4452e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9721,
      y: 800,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '801aa369-d9ba-4ed5-8a39-feebda800f6f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9658,
      y: 737,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '72d86977-8b24-4d74-b738-4dbdd558e4f0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9696,
      y: 660,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'f4d8fe89-1e0e-4544-862a-dc6e6f0cd86b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9807,
      y: 766,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '5ac4667b-2bd0-4ca9-9fe9-75bc4a1f9d12',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9787,
      y: 631,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '5dae38f9-b4a1-46db-b6c1-d15cdd04f30b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9836,
      y: 684,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'dc97e4f5-73ee-416b-b47d-edbf2906d175',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9897,
      y: 745,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'f9c1bf01-830a-4355-b44a-4ac1c27e2b62',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9879,
      y: 612,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '83bfbd39-db49-49ce-9641-52cbadc34bc3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9929,
      y: 670,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b22efb7e-9f63-483c-adb6-b28996c8fc97',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9989,
      y: 726,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '6d44a089-5273-47c2-ada1-8c65e745bf3f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9992,
      y: 623,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2b31b5ff-f6ca-44a7-9406-2716cfe9e2fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10049,
      y: 676,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '6a2296c1-d62a-4725-b609-9a4c606f7205',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10110,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '7fc48ffc-78e9-4937-be24-939648c281c8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10053,
      y: 773,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'f32677c6-dfc9-48b4-8de1-16980efc86a2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10447,
      y: 752,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '6064afc9-401f-496c-984d-a79a8ab9783f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10181,
      y: 704,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '3b61b171-6944-4cbb-9c71-0ee719226adb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10164,
      y: 792,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b11b99ff-e4f9-41c6-af91-b059329f7742',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10245,
      y: 757,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '33fabf67-0ec2-4a55-80cd-f664f7bb6368',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10248,
      y: 660,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '5f770981-d794-4d27-928f-c8d3940baa41',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10314,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'fe57051c-439d-477a-959e-7cda888a3e17',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10368,
      y: 783,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'c552021f-843b-4e93-b5a9-ce45813f4cda',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10382,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '5cd8bfcd-e838-430d-97d9-7480d44d71f1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10112,
      y: 636,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'f5f4ec5e-0398-43bb-9eac-5a6df679a67d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9755,
      y: 714,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '0717c607-df9f-40eb-a3cd-5108f09e496f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9856,
      y: 67,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'f8dfc0cb-ceac-4716-aadf-5d1b99fef366',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9917,
      y: 130,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '574257ea-5905-45c0-8436-46c572f8b205',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9984,
      y: 181,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '8e5c0190-4253-4733-bbe9-ff23fc6f8b2f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10051,
      y: 236,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2edb795e-c9e4-4585-b859-5eae104b1ef7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10212,
      y: 291,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'f65ef7bf-da0d-4871-a90b-1d82bfd3f2bd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10144,
      y: 235,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '9c9d5c6b-38b6-4970-ba13-9dc9cd085a79',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10058,
      y: 154,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2d78762d-7744-44b9-b14b-ab4da1c38357',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9985,
      y: 85,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'e82ea7f5-1ee3-4627-ba89-bd3f72473cb4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10270,
      y: 226,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '14afa991-c608-4998-bd0e-e71ae4e26cf1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10204,
      y: 175,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '692a7312-a900-40dc-957e-a966904f62e4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10134,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2e0364a1-ef50-46cf-b5cd-a91446018cf5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10062,
      y: 54,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '02d00a2c-10b0-4815-88e6-8dd7fb81265a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9926,
      y: 24,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'c25cb5e0-88f9-4971-850b-9b38b614777a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10330,
      y: 185,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '9ace1a01-6be9-4996-86ce-fb91132a7ecb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10265,
      y: 118,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '9b585768-5558-43c6-b71e-ed215c867c6b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10196,
      y: 66,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '30cdfa1f-4ab8-4e63-b2f9-f941d5161f56',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10332,
      y: 92,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '87436acc-d902-4368-94c5-8f634c067c05',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10263,
      y: 26,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 921,
      y: 252,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '106',
      data: ''
    },
    {
      id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1813,
      y: 324,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '160',
      data: ''
    },
    {
      id: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3804,
      y: 353,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '631194d4-ad73-4366-a65f-21797e8dc249',
      data: ''
    },
    {
      id: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5141,
      y: 320,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: 'af38acd5-a0e4-43d7-856f-fef8f3b120a3',
      data: ''
    },
    {
      id: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6325,
      y: 560,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '74092e03-0544-42a0-a499-3278f19873a5',
      data: ''
    },
    {
      id: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7636,
      y: 554,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '583acaed-3914-470b-a17f-69f0e67d92ab',
      data: ''
    },
    {
      id: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8595,
      y: 303,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: 'ea7f8b33-ad80-48d6-98f7-0540c1ec4100',
      data: ''
    },
    {
      id: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10108,
      y: 329,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '214ea0e2-d913-4c42-a718-1f4bc72d2b79',
      data: ''
    },
    {
      id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '85746295-e987-4e2b-a7d0-6791216b55a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_harvest_map',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '656a5808-34d6-4751-a733-6af98d163ac6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'turnip_harvest_map',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '5e0141b9-e88c-4195-9c3a-41026c2f0f02',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      data: ''
    },
    {
      id: 'eac7b762-4daa-4f48-a00f-fa9842083630',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_harvest_map',
      parent: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      data: ''
    },
    {
      id: '1c1c11b6-3bec-42ac-9ba7-734666ce9f9e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      data: ''
    },
    {
      id: 'd1659629-b52b-4f7a-9540-f46fdd47b041',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'foxgloves_harvest_map',
      parent: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      data: ''
    },
    {
      id: 'c0951141-6c84-4809-9f82-95dafdb20791',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      data: ''
    },
    {
      id: '9b6a42ce-3523-4770-bb25-bf8564dbb68a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_harvest_map',
      parent: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      data: ''
    },
    {
      id: 'eebc8c9c-a331-443b-916c-21e0b62c9e5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      data: ''
    },
    {
      id: '37c498a2-2982-4a27-ab11-ad78a4d1b579',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gooseberry_harvest_map',
      parent: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      data: ''
    },
    {
      id: '58315196-25c5-41cf-b5b5-2686aef5cf8f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      data: ''
    },
    {
      id: 'd042d300-813b-485a-9131-9c87b3fd752e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_harvest_map',
      parent: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      data: ''
    },
    {
      id: '02371518-93f5-4aa0-9cbf-601b79c46a84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      data: ''
    },
    {
      id: 'a0c529bc-64cb-4fdf-b45c-523b7628ab68',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'celery_harvest_map',
      parent: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class WorldLayout29 {
  static raw = raw;
  root: PIXI.Container
  backgrounds: PIXI.Container
  nodesContainer: PIXI.Container
  cropsSectorA: (PIXI.Container)[]
  cropsSectorB: (PIXI.Container)[]
  signsSectorA: (PIXI.Container)[]
  signsSectorB: (PIXI.Container)[]

  constructor() {
    populate(this, raw);
  }
}
